const fetchSiblingsSwatches = async siblings => {
  // console.log('fetchSiblingsSwatches')
  // console.log(siblings)
  let round = 0
  const siblingsToFetch = []

  siblings.forEach(sibling => {
    if (!store.hasRow('swatches', sibling)) {
      // needs to call API
      siblingsToFetch.push(sibling)
      store.setRow('swatches', sibling, {})
    } else {
      // object in memory
      round++
      if (round === siblings.length) {
        numberOfProductFetched++
      }

      // console.log(
      //   `From memory : Turn ${numberOfProductFetched} of ${numberOfProductInPage} | round ${round} of ${siblings.length} `
      // )
      const storedData = store.getRow('swatches', sibling)

      if (storedData.title) {
        const data = {
          handle: sibling,
          color_primary: storedData.color_primary,
          color_secondary: storedData.color_secondary,
          color_tertiary: storedData.color_tertiary,
          id: storedData.id,
          title: storedData.title,
        }
        buildSwatch(data)
      }

      isLastFetch = numberOfProductFetched === numberOfProductInPage && round === siblings.length

      if (isLastFetch) {
        // console.log('is last!')
        removeBrokenSwatches()
      }
    }
  })

  if (siblingsToFetch.length) {
    const productsUrl = await getIdFromHandles(siblingsToFetch)

    if (productsUrl.length) {
      // console.log(`From API : Turn ${numberOfProductFetched} of ${numberOfProductInPage}`)
      await fetchDataFromShopify(productsUrl)
    }
    numberOfProductFetched++
    isLastFetch = numberOfProductFetched === numberOfProductInPage

    if (isLastFetch) {
      // console.log('is last!')
      removeBrokenSwatches()
    }
  }
}

const getIdFromHandles = async siblingsToFetch => {
  const productsUrl = []
  try {
    let sibling
    await Promise.all(
      siblingsToFetch.map(handle => {
        sibling = handle
        return fetch('/products/' + handle + '.js')
      })
    )
      .then(responses => {
        return Promise.all(
          responses
            .filter(res => res.status === 200)
            .map(response => {
              return response.json()
            })
        ).catch(error => {
          console.log(error)
        })
      })
      .then(function (data) {
        data.forEach(product => {
          store.setPartialRow('swatches', sibling, { id: product.id })
          productsUrl.push('gid://shopify/Product/' + product.id)
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  } catch (err) {
    console.log(err)
  }
  return productsUrl
}

const fetchDataFromShopify = async productsUrl => {
  try {
    const rawResponse = await fetch('http://wpstore-backend-git-develop-mirror-digital.vercel.app/api/products', {
      // const rawResponse = await fetch('http://localhost:3000/api/products', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ids: productsUrl }),
    })
    const productsData = await rawResponse.json()

    // console.log('received Data!')
    // console.log(productsData)

    productsData.forEach(async data => {
      if (data) {
        const swatchRow = {
          color_primary: (data.color_primary && data.color_primary.value) || false,
          color_secondary: (data.color_secondary && data.color_secondary.value) || false,
          color_tertiary: (data.color_tertiary && data.color_tertiary.value) || false,
          id: data.id,
          title: data.title,
        }
        store.setPartialRow('swatches', data.handle, swatchRow)
        if (data.handle) {
          buildSwatch({ ...swatchRow, handle: data.handle })
        }
      }
    })
  } catch (err) {
    console.log(err)
  }
}

const buildSwatch = data => {
  var thisSwatches = document.querySelectorAll('.product__color-swatch-color#swatch-' + data.handle)
  // console.log(`BUILD! round ${numberOfProductFetched} of ${numberOfProductInPage}`)
  // console.log(`data:`)
  // console.log(data)
  if (data.hasOwnProperty('color_primary')) {
    thisSwatches.forEach(swatch => {
      swatch.classList.remove('product__color-swatch-color--undefined')
      if (data.color_tertiary) {
        swatch.style.background = `linear-gradient(90deg, ${data.color_primary} 25%,${data.color_secondary} 50%, ${data.color_tertiary} 75%)`
      } else if (data.color_secondary) {
        swatch.style.background = `linear-gradient(90deg, ${data.color_primary} 50%, ${data.color_secondary} 50%)`
      } else if (data.color_primary) {
        swatch.style.background = data.color_primary
      } else {
        console.log('NO COLOR???')
        swatch.classList.add('product__color-swatch-color--undefined')
      }
    })
  } else {
    thisSwatches.forEach(function (swatch) {
      swatch.style.backgroundColor = '#fff'
    })
  }
}

const removeBrokenSwatches = () => {
  const brokenSwatches = document.querySelectorAll('.product__color-swatch-color--undefined')
  // console.log('end of the trail | removing nodes: ', brokenSwatches.length)
  // console.log(brokenSwatches)
  brokenSwatches.forEach(brokenSwatch => {
    brokenSwatch.style.display = 'none'
  })
  isLastFetch = false
  numberOfProductFetched = 0
}
